import { render } from "./Profile.vue?vue&type=template&id=5dd587b4"
import script from "./Profile.vue?vue&type=script&lang=js"
export * from "./Profile.vue?vue&type=script&lang=js"

import "./Profile.vue?vue&type=style&index=0&id=5dd587b4&lang=scss"
import "./Profile.vue?vue&type=style&index=1&id=5dd587b4&lang=css"

import exportComponent from "/home/ubuntu/jalizan/webapp/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__